export default "__VITE_ASSET__lihbRgxz__"